// Extra requirements functions
import { filterObjectByFunction, isNullOrUndefined } from '../community-hats-js-library/utils/generalFunctions';
import {
  getATOInsideSetFields,
  getATOInsideSetStatus,
  getKeysOfATOSet,
  refreshATObject,
  refreshATOInsideSet,
  setStoredValue,
} from '../hooks/StoreHooks';
import * as locCon from '../LocalConstants';
import * as libCon from '../community-hats-js-library/Constants';

export const getPendingExtraRequests = async () => {
  let status = await Promise.all(locCon.EXTRA_REQUESTS_TO_CHECK.map(async (r) => await getStatusForExtraRequest(r)));
  let pending = locCon.EXTRA_REQUESTS_TO_CHECK.filter((_, i) => status[i] === locCon.EXTRA_REQUEST_STATUS_PENDING);
  return pending;
};

export const getStatusOfNewPositionForSensorPlacements = async () => {
  let positionsIds = getKeysOfATOSet();

  // Refreshes all sensor placements
  await Promise.all(
    positionsIds.map(async (posId) => await refreshATOInsideSet(posId, locCon.AT_OBJECT_SENSORS_HOUSE_PLACEMENT))
  );

  // Checks if the current position is empty
  let sensorPlacements = positionsIds.map((posId) =>
    getATOInsideSetFields(posId, locCon.AT_OBJECT_SENSORS_HOUSE_PLACEMENT)
  );
  let sensorPlacementStatus = positionsIds.map((posId) =>
    getATOInsideSetStatus(posId, locCon.AT_OBJECT_SENSORS_HOUSE_PLACEMENT)
  );

  let missingPosition = sensorPlacements.map(
    (sp, i) =>
      !isNullOrUndefined(sp) &&
      sp[libCon.ATF_ACTIVE] === libCon.YES &&
      sensorPlacementStatus[i] === locCon.ATO_UP_TO_DATE &&
      (!(libCon.ATF_POSITION in sp) || sp[libCon.ATF_SENSOR_POSITION_CHECKED_STATUS] === libCon.ATF_PENDING)
  );

  // Updates the missing positions

  let missingPositionIds = Object.fromEntries(positionsIds.map((key, i) => [key, missingPosition[i]]));

  // Sets the store
  // Updates the vector
  let missingPositionIdsVector = Object.keys(filterObjectByFunction(missingPositionIds, (v) => v === true));
  missingPositionIdsVector.forEach((posId) => setStoredValue(locCon.getUpdateSensorPositionCheckBoxId(posId), false));
  setStoredValue(locCon.EXTRA_REQUEST_UPDATE_SENSOR_POSITION_MISSING_IDS, missingPositionIdsVector);

  return missingPositionIds;
};

export const getStatusOfPhotoRetakeSensorPlacements = async () => {
  let positionsIds = getKeysOfATOSet();

  // Refreshes all sensor placements
  await Promise.all(
    positionsIds.map(async (posId) => await refreshATOInsideSet(posId, locCon.AT_OBJECT_SENSORS_HOUSE_PLACEMENT))
  );

  // Checks if the current position is empty
  let sensorPlacements = positionsIds.map((posId) =>
    getATOInsideSetFields(posId, locCon.AT_OBJECT_SENSORS_HOUSE_PLACEMENT)
  );
  let sensorPlacementStatus = positionsIds.map((posId) =>
    getATOInsideSetStatus(posId, locCon.AT_OBJECT_SENSORS_HOUSE_PLACEMENT)
  );

  let needsRetake = sensorPlacements.map(
    (sp, i) =>
      !isNullOrUndefined(sp) &&
      sp[libCon.ATF_ACTIVE] === libCon.YES &&
      sensorPlacementStatus[i] === locCon.ATO_UP_TO_DATE &&
      libCon.ATF_PHOTO_RETAKE_STATUS in sp &&
      sp[libCon.ATF_PHOTO_RETAKE_STATUS] === libCon.ATF_PENDING
  );

  // Updates the missing positions
  let needsRetakePositionIds = Object.fromEntries(positionsIds.map((key, i) => [key, needsRetake[i]]));

  // Sets the store
  // Updates the vector
  let needsRetakePositionIdsVector = Object.keys(filterObjectByFunction(needsRetakePositionIds, (v) => v === true));
  needsRetakePositionIdsVector.forEach((posId) => setStoredValue(locCon.getUpdateSensorPhotoCheckBoxId(posId), false));
  setStoredValue(locCon.EXTRA_REQUEST_UPDATE_SENSOR_PHOTO_IDS, needsRetakePositionIdsVector);

  return needsRetakePositionIds;
};

export const getStatusForExtraRequest = async (extraRequest) => {
  // General variables

  switch (extraRequest) {
    case locCon.EXTRA_REQUEST_UPDATE_SENSOR_POSITION:
      let missingDict = await getStatusOfNewPositionForSensorPlacements();

      if (Object.values(missingDict).some((mp) => mp === true)) return locCon.EXTRA_REQUEST_STATUS_PENDING;
      else return locCon.EXTRA_REQUEST_STATUS_COMPLETE;

    case locCon.EXTRA_REQUEST_UPDATE_SENSOR_PHOTO:
      let retakeDict = await getStatusOfPhotoRetakeSensorPlacements();

      if (Object.values(retakeDict).some((mp) => mp === true)) return locCon.EXTRA_REQUEST_STATUS_PENDING;
      else return locCon.EXTRA_REQUEST_STATUS_COMPLETE;

    case locCon.EXTRA_REQUEST_UPDATE_MISSING_SEWA_ID:
      // Updates the participant object
      await refreshATObject(locCon.AT_OBJECT_PARTICIPANT);

      // Always return complete. It mmight break something if the SEWA ID becommes null for some reason
      return locCon.EXTRA_REQUEST_STATUS_COMPLETE;

    case locCon.EXTRA_REQUEST_UPDATE_FITBIT_API_TOKEN:
      // Updates the email object
      const email = await refreshATObject(locCon.AT_OBJECT_EMAIL_ACCOUNT);

      if (
        !isNullOrUndefined(email[libCon.ATF_FITBIT_TOKEN_STATUS]) &&
        email[libCon.ATF_FITBIT_TOKEN_STATUS] === libCon.ATF_ACTIVE
      )
        return locCon.EXTRA_REQUEST_STATUS_COMPLETE;
      else return locCon.EXTRA_REQUEST_STATUS_PENDING;

    case locCon.EXTRA_REQUEST_UPDATE_GOOGLE_HEALTH_API_TOKEN:
      // Updates the email object
      const email2 = await refreshATObject(locCon.AT_OBJECT_EMAIL_ACCOUNT);

      if (
        !isNullOrUndefined(email2[libCon.ATF_GOOGLE_TOKEN_STATUS]) &&
        email2[libCon.ATF_GOOGLE_TOKEN_STATUS] === libCon.ATF_ACTIVE
      )
        return locCon.EXTRA_REQUEST_STATUS_COMPLETE;
      else return locCon.EXTRA_REQUEST_STATUS_PENDING;

    default:
      throw new Error(`Invalid extra request status: ${extraRequest}`);
  }
};
